import { useOrchestratorApi } from '@/composables/orchestrator/useOrchestratorApi'
import type { WidgetUiOptions } from '@/composables/orchestrator/types'

const getOptions = async () => {
    const client = useOrchestratorApi()

    const response = await client.request<Partial<WidgetUiOptions> | null>({
        method: 'get',
        url: `/workflows/ui-options`,
    })

    return response.data
}

export const useRemoteWidgetOptions = () => {
    return {
        getOptions,
    }
}
